import { Modal, Radio } from 'antd';
import t from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Button } from '@frontend/components';

import AddressOverview from 'components/AddressOverview/AddressOverview';

const SectionLayout = styled.div`
  margin-top: 15px;

  ${(props) =>
    props.horizontal &&
    `
    display: flex;
    justify-content: space-around;
  `};
`;

const Section = styled.section`
  margin-bottom: 15px;

  h3 {
    font-size: 14px;
    font-weight: 500;
  }
`;

const AddressOptionWrapper = styled.div`
  display: flex;
  cursor: pointer;
  padding: 5px;
  width: 200px;
  word-break: break-word;

  :hover {
    background: #efefef;
  }

  > :first-of-type {
    margin-right: 10px;
  }
`;

const AddressOptionList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const EditThisAddress = styled.span`
  font-size: 14px;
  font-weight: 500;
  margin-right: 20px;
`;

const AddressOption = ({ address, checked, onClick }) => {
  return (
    <AddressOptionWrapper onClick={onClick}>
      <Radio checked={checked} />
      <AddressOverview address={address} />
    </AddressOptionWrapper>
  );
};

class AddressValidationModal extends React.Component {
  static propTypes = {
    originalAddress: t.object.isRequired,
    suggestedAddresses: t.array,
    confirmAddress: t.func.isRequired,
    editAddress: t.func.isRequired,
    cancelAddressValidation: t.func.isRequired,
  };

  state = {
    selected: -1,
  };

  getSelectedAddress = () => {
    const { selected } = this.state;
    return selected === -1
      ? this.props.originalAddress
      : this.props.suggestedAddresses[selected];
  };

  handleSelectedChange = (index) => () => {
    this.setState({
      selected: index,
    });
  };

  handleEdit = () => {
    this.props.editAddress(this.getSelectedAddress());
  };

  handleConfirm = () => {
    this.props.confirmAddress(this.getSelectedAddress());
  };

  render() {
    const {
      originalAddress,
      suggestedAddresses,
      cancelAddressValidation,
      title,
    } = this.props;
    const { selected } = this.state;
    return (
      <Modal
        title={title || 'Verify Shipping Address'}
        visible={true}
        maskClosable={false}
        width={700}
        footer={
          <div>
            <EditThisAddress>
              <button className="link link_special" onClick={this.handleEdit}>
                Edit This Address
              </button>
            </EditThisAddress>
            <Button
              data-testid="use-this-address-button"
              variant="primary"
              onClick={this.handleConfirm}
            >
              Use This Address
            </Button>
          </div>
        }
        onOk={() => 0}
        onCancel={cancelAddressValidation}
      >
        <p>
          To ensure accurate delivery, we suggest the changes highlighted below.
          Please choose which address you would like to use. If neither option
          is correct,&nbsp;
          <button
            className="link link_special"
            onClick={cancelAddressValidation}
          >
            edit your address
          </button>
          .
        </p>

        <SectionLayout horizontal={suggestedAddresses.length === 1}>
          <Section>
            <h3>Original Address</h3>
            <AddressOption
              address={originalAddress}
              checked={selected === -1}
              onClick={this.handleSelectedChange(-1)}
            />
          </Section>

          <Section>
            <h3>
              Suggested Address
              {suggestedAddresses.length > 1 ? 'es' : ''}
            </h3>
            <AddressOptionList>
              {suggestedAddresses.map((address, index) => (
                <AddressOption
                  key={index}
                  address={address}
                  checked={selected === index}
                  onClick={this.handleSelectedChange(index)}
                />
              ))}
            </AddressOptionList>
          </Section>
        </SectionLayout>
      </Modal>
    );
  }
}

export default AddressValidationModal;
